(function () {
  if (window.__ioosilkPdpFinalFix20260726) return;
  window.__ioosilkPdpFinalFix20260726 = true;

  var GOLD = '#c79818';
  var busy = false;
  var keepAliveTimer = null;

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function closest(target, selector) {
    var el = target && target.nodeType === 1 ? target : target && target.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function norm(value) {
    return String(value == null ? '' : value).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isProductPage() {
    return Boolean(qs('#velvet-pdp-stable-v102') && qs('#pdp-add-form') && qs('#buy-btn'));
  }

  function localVariants() {
    var el = qs('#v-json');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || el.innerHTML || '[]');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function selectedOptions() {
    return qsa('.opt-row').map(function (row) {
      var active = qs('.opt-box.active', row) || qs('.opt-box', row);
      return norm(active && (active.getAttribute('data-val') || active.textContent));
    });
  }

  function variantMatches(variant, selected) {
    return Boolean(variant) && Array.isArray(variant.options) && variant.options.every(function (option, index) {
      return norm(option) === selected[index];
    });
  }

  function findVariant() {
    var variants = localVariants();
    var selected = selectedOptions();
    var exact = variants.find(function (variant) { return variantMatches(variant, selected); });
    var input = qs('#v-id');
    var inputId = input && input.value;
    var byInput = variants.find(function (variant) { return String(variant.id) === String(inputId); });
    var available = variants.find(function (variant) { return variant && variant.available !== false; });
    return exact || byInput || available || variants[0] || null;
  }

  function selectByVariant(variant) {
    if (!variant || !Array.isArray(variant.options)) return;
    qsa('.opt-row').forEach(function (row, index) {
      var wanted = norm(variant.options[index]);
      var option = qsa('.opt-box', row).find(function (box) {
        return norm(box.getAttribute('data-val') || box.textContent) === wanted;
      });
      if (!option) return;
      qsa('.opt-box', row).forEach(function (box) { box.classList.remove('active'); });
      option.classList.add('active');
    });
  }

  function styleOptions() {
    qsa('.opt-box').forEach(function (box) {
      var active = box.classList.contains('active');
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-pressed', active ? 'true' : 'false');
      box.style.setProperty('opacity', '1', 'important');
      box.style.setProperty('cursor', 'pointer', 'important');
      box.style.setProperty('border-color', active ? GOLD : 'rgba(0,0,0,.18)', 'important');
      box.style.setProperty('box-shadow', active ? '0 0 0 1px rgba(199,152,24,.45) inset' : 'none', 'important');
      box.style.setProperty('color', active ? GOLD : '', 'important');
    });
  }

  function clearSoldOutMessages() {
    qsa('[data-ioosilk-cart-message], [data-ioosilk-product-message]').forEach(function (message) {
      if (/sold out/i.test(message.textContent || '')) message.textContent = '';
    });
  }

  function forcePurchasableButton() {
    if (!isProductPage() || busy) return;
    var button = qs('#buy-btn');
    var form = qs('#pdp-add-form');
    if (form) {
      form.removeAttribute('onsubmit');
      form.setAttribute('novalidate', 'novalidate');
      form.dataset.ioosilkVariantAvailable = 'true';
    }
    if (button) {
      button.type = 'button';
      button.disabled = false;
      button.removeAttribute('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.setAttribute('aria-live', 'polite');
      if (/sold out/i.test(button.textContent || '')) button.textContent = 'ADD TO CART';
    }
    clearSoldOutMessages();
  }

  function syncVariant() {
    if (!isProductPage()) return null;
    var variant = findVariant();
    if (!variant) return null;
    selectByVariant(variant);
    var input = qs('#v-id');
    if (input) input.value = variant.id;
    var price = money(variant.price);
    var priceEl = qs('#p-price');
    var currentPrice = qs('#current-price');
    if (priceEl) priceEl.textContent = price;
    if (currentPrice) currentPrice.textContent = 'Selected: ' + price;
    if (variant.img_id) {
      qsa('.g-thumb').some(function (thumb, index) {
        if (String(thumb.getAttribute('data-id')) !== String(variant.img_id)) return false;
        switchGallery(index, thumb);
        return true;
      });
    }
    styleOptions();
    forcePurchasableButton();
    return variant;
  }

  function switchGallery(index, thumb) {
    var gallery = qs('#g-scroll');
    if (!gallery) return;
    var slides = qsa('.g-slide', gallery);
    var safe = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
    var slide = slides[safe];
    if (!slide) return;
    if (gallery.scrollTo) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    else gallery.scrollLeft = slide.offsetLeft;
    qsa('.g-thumb').forEach(function (item) { item.classList.remove('active'); });
    (thumb || qsa('.g-thumb')[safe] || {}).classList && (thumb || qsa('.g-thumb')[safe]).classList.add('active');
  }

  async function publicProductVariantForSelection() {
    var selected = selectedOptions();
    var response = await fetch(window.location.pathname + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return null;
    var product = await response.json();
    var variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function (variant) {
      return variant.available !== false && variantMatches(variant, selected);
    }) || null;
  }

  function drawer() {
    return qs('#velvet-cart-drawer');
  }

  function backdrop() {
    return qs('#cart-backdrop');
  }

  function forceDrawer(open) {
    var d = drawer();
    var b = backdrop();
    if (!d) return false;
    d.classList.toggle('translate-x-full', !open);
    d.classList.toggle('hidden', false);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.style.setProperty('position', 'fixed', 'important');
    d.style.setProperty('top', '0', 'important');
    d.style.setProperty('right', '0', 'important');
    d.style.setProperty('bottom', '0', 'important');
    d.style.setProperty('left', 'auto', 'important');
    d.style.setProperty('width', 'min(440px, 92vw)', 'important');
    d.style.setProperty('height', '100vh', 'important');
    d.style.setProperty('transform', open ? 'translateX(0)' : 'translateX(100%)', 'important');
    d.style.setProperty('visibility', 'visible', 'important');
    d.style.setProperty('display', 'block', 'important');
    d.style.setProperty('z-index', '2147483200', 'important');
    if (b) {
      b.classList.toggle('opacity-0', !open);
      b.classList.toggle('pointer-events-none', !open);
      b.setAttribute('aria-hidden', open ? 'false' : 'true');
      b.style.setProperty('position', 'fixed', 'important');
      b.style.setProperty('inset', '0', 'important');
      b.style.setProperty('opacity', open ? '1' : '0', 'important');
      b.style.setProperty('pointer-events', open ? 'auto' : 'none', 'important');
      b.style.setProperty('background', 'rgba(0,0,0,.42)', 'important');
      b.style.setProperty('z-index', '2147483100', 'important');
    }
    document.body.classList.toggle('velvet-cart-open', open);
    return true;
  }

  function setCartCount(count) {
    qsa('.cart-count, [data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  async function getCart() {
    var response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart load failed');
    return response.json();
  }

  async function renderCart() {
    var cart = await getCart();
    setCartCount(cart.item_count || 0);
    var subtotal = qs('#cart-subtotal');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    var wrap = qs('#cart-items-container');
    if (!wrap) return cart;
    if (!cart.item_count) {
      wrap.innerHTML = '<div class="ioosilk-cart-empty">Your selection is empty</div>';
      return cart;
    }
    wrap.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '';
      return '<div class="ioosilk-cart-item" data-cart-item>' +
        '<div class="ioosilk-cart-item__image">' + img + '</div>' +
        '<div class="ioosilk-cart-item__body"><div><h3 class="ioosilk-cart-item__title">' + escapeHtml(item.product_title) + '</h3>' +
        '<p class="ioosilk-cart-item__variant">' + escapeHtml(item.variant_title || '') + '</p></div>' +
        '<div class="ioosilk-cart-item__controls"><div class="ioosilk-cart-qty">' +
        '<button type="button" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="' + (item.quantity - 1) + '">-</button>' +
        '<span data-cart-qty-value>' + item.quantity + '</span>' +
        '<button type="button" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div><div><span class="ioosilk-cart-item__price">' + money(item.line_price) + '</span>' +
        '<button type="button" class="ioosilk-cart-remove" data-cart-key="' + escapeHtml(item.key) + '" data-cart-qty="0">Remove</button></div></div></div></div>';
    }).join('');
    return cart;
  }

  function openCart() {
    if (!forceDrawer(true)) {
      window.location.href = '/cart';
      return;
    }
    renderCart().catch(function () {});
  }

  function closeCart() {
    forceDrawer(false);
  }

  function message(form, text, isError) {
    if (!form) return;
    var el = qs('[data-ioosilk-cart-message]', form) || qs('[data-ioosilk-product-message]', form);
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-ioosilk-cart-message', '');
      el.setAttribute('role', 'status');
      el.style.cssText = 'margin:12px 0 0;font-family:Cinzel,serif;font-size:10px;letter-spacing:.16em;text-transform:uppercase;text-align:center;';
      form.appendChild(el);
    }
    el.style.color = isError ? '#9a1f32' : GOLD;
    el.textContent = text || '';
  }

  async function postVariant(id) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    });
    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      var error = new Error(data.description || data.message || 'Unable to add this item.');
      error.data = data;
      throw error;
    }
    return data;
  }

  async function addToCart() {
    var form = qs('#pdp-add-form');
    if (!form || busy) return;
    var button = qs('#buy-btn');
    var variant = syncVariant();
    var id = variant && variant.id || (qs('#v-id') || {}).value || new FormData(form).get('id');
    if (!id) {
      message(form, 'Please choose an option.', true);
      return;
    }

    busy = true;
    if (button) {
      button.dataset.ioosilkOriginalText = 'ADD TO CART';
      button.disabled = true;
      button.textContent = 'ADDING...';
    }
    message(form, '', false);

    try {
      try {
        await postVariant(id);
      } catch (firstError) {
        if (!/sold out|unavailable/i.test(firstError.message || '')) throw firstError;
        var publicVariant = await publicProductVariantForSelection().catch(function () { return null; });
        if (!publicVariant || String(publicVariant.id) === String(id)) throw firstError;
        id = publicVariant.id;
        var input = qs('#v-id');
        if (input) input.value = id;
        await postVariant(id);
      }
      var cart = await renderCart();
      setCartCount(cart.item_count || 0);
      message(form, 'Added to cart.', false);
      if (button) {
        button.classList.add('is-added');
        button.textContent = 'ADDED';
      }
      openCart();
      window.setTimeout(function () {
        if (button) {
          button.classList.remove('is-added');
          button.textContent = 'ADD TO CART';
        }
      }, 900);
    } catch (error) {
      message(form, error && error.message ? error.message : 'Unable to add this item.', true);
      if (button) button.textContent = 'ADD TO CART';
    } finally {
      busy = false;
      if (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      }
      forcePurchasableButton();
    }
  }

  function selectOption(option) {
    var row = closest(option, '.opt-row');
    if (!row) return;
    qsa('.opt-box', row).forEach(function (box) { box.classList.remove('active'); });
    option.classList.add('active');
    syncVariant();
  }

  function handleClick(event) {
    var option = closest(event.target, '.opt-box');
    if (option) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectOption(option);
      return;
    }
    var add = closest(event.target, '#buy-btn');
    if (add) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart();
      return;
    }
    var cart = closest(event.target, '.cart-trigger, .search-cart-v1, .ioosilk-unified-nav__cart, [data-ioosilk-cart-go], a[href="/cart"], a[href^="/cart?"]');
    if (cart && !closest(cart, '#velvet-cart-drawer')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCart();
      return;
    }
    var close = closest(event.target, '[data-cart-close], #cart-backdrop');
    if (close) {
      event.preventDefault();
      closeCart();
      return;
    }
    var qty = closest(event.target, '[data-cart-key][data-cart-qty]');
    if (qty) {
      event.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: qty.getAttribute('data-cart-key'), quantity: Number(qty.getAttribute('data-cart-qty')) })
      }).then(renderCart).catch(function () { renderCart().catch(function () {}); });
    }
  }

  function install() {
    if (!isProductPage()) return;
    document.removeEventListener('click', handleClick, true);
    document.addEventListener('click', handleClick, true);
    document.removeEventListener('submit', handleSubmit, true);
    document.addEventListener('submit', handleSubmit, true);
    window.openCart = openCart;
    window.closeCart = closeCart;
    window.ioosilkOpenCartDrawer = openCart;
    window.addToCart = addToCart;
    window.pOpt = function (el) { selectOption(el); };
    window.upd = function () { syncVariant(); };
    syncVariant();
    forcePurchasableButton();
    if (keepAliveTimer) window.clearInterval(keepAliveTimer);
    var ticks = 0;
    keepAliveTimer = window.setInterval(function () {
      ticks += 1;
      syncVariant();
      forcePurchasableButton();
      if (ticks > 80) window.clearInterval(keepAliveTimer);
    }, 250);
  }

  function handleSubmit(event) {
    if (!event.target || event.target.id !== 'pdp-add-form') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart();
  }

  ready(function () {
    window.setTimeout(install, 0);
    window.setTimeout(install, 300);
    window.setTimeout(install, 1200);
    window.setTimeout(install, 3000);
  });
  window.addEventListener('pageshow', install);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) install();
  });
})();
